/**
* @summary - Component that Provides PPM GENERATION functionality
* @autor vengateshwaran k
* @since 2024-06-21
*/
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography
} from "@mui/material";
import { endOfMonth, format, formatISO, getMonth, getYear, startOfMonth } from 'date-fns';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import commonMasterRepository from "../../api/repositories/commonMasterRepository";
import PpmGenerationRepository from "../../api/repositories/ppmGenerationRepository";
import PpmPlannerRepository from "../../api/repositories/ppmPlannerRepository";
import { DefaultCard } from "../../assets/styled-components/card";
import { setHeaderName, setSelectedIndex } from "../../redux/actions/userActions";
import commonMessages from "../../utility/constant";
import {
  getAuthToken
} from "../../utility/tokenUtility";
import CustomAgGrid from "../commoncomponents/CustomAgGrid";
import CustomDialog from '../commoncomponents/CustomDialog';
import CustomSelectInput from '../commoncomponents/CustomSelectInput';
import CustomTextField from "../commoncomponents/CustomTextField";
import PageLoader from "../commoncomponents/PageLoader";
import RefreshExportButtons from '../commoncomponents/RefreshExportButtons';
import Kpirepairdownload from './Kpirepairdownload';
import Repaireportform from "./Repairreportform";
import PPMCheckListRepository from "../../api/repositories/ppmChecklistRepository";
import axios from "axios";
import utilities from "../../utility/utilities";
import { MasterGraph } from "../../utility/apiURLS";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
const ActionsCellRenderer = ({ data, ppmCheckList, serviceType }) => {
  const [isPrintable, setIsPrintable] = useState(false);
  const [ppmList, setPpmList] = useState(null);

  useEffect(() => {
    let result;
    if (serviceType?.label === "FEMS") {
      result = ppmCheckList?.filter(
        (item) =>
          item?.femtaskdetailsId === data?.femtaskdetailsId &&
          item?.typecodeId === data?.typecodeid
      );
    } else if (serviceType?.label === "BEMS") {
      result = ppmCheckList?.filter(
        (item) =>
          item?.bemtaskdetailsId === data?.bemtaskdetailsId &&
          item?.typecodeId === data?.typecodeid
      );
    }

    if (result?.length > 0) {
      setPpmList(result);
      setIsPrintable(true);
    } else {
      setIsPrintable(false);
      setPpmList(null);
    }
  }, [data, ppmCheckList, serviceType]);

  const handleDownload = async (data) => {
    try {
      const token = getAuthToken("id_token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
      };
      const response = await axios.get(
        `${MasterGraph}/api/FileUpload/DownloadFile/${data[0]?.filename}`,
        config
      );

      if (response.status === 200) {
        const contentType = response.headers["content-type"];
        const extension = utilities.getExtensionFromContentType(contentType);
        const blobUrl = window.URL.createObjectURL(response.data);
        const filename = `${data[0].documenttitle}`;
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(blobUrl);
      }
    } catch (error) {
      console.log("Error downloading file:", error);
      return error.response;
    }
  };

  return (
    <>
      {isPrintable && (
        <span
          style={{
            display: "block",
            margin: "4px 0px",
            cursor: "pointer",
            textAlign: "center",
            textDecoration: "underline",
            color: "gray",
          }}
          onClick={() => handleDownload(ppmList)}
        >
          <FileDownloadIcon />
        </span>
      )}
    </>
  );
};


const PpmGenerationList = ({ facilityId, companyId }) => {
  const dispatch = useDispatch();
  const gridRef = useRef(null);
  const [gridApi, setGridApi] = useState({});
  const [serviceType, setServiceType] = useState();
  const [serviceTypeOptions, setServiceTypeOptions] = useState([]);
  const [workGroup, setWorkGroup] = useState();
  const [isView, setIsView] = useState(false);
  const [workGroupOptions, setWorkGroupOptions] = useState([]);
  const [year, setYear] = useState();
  const [yearOptions, setYearOptions] = useState([]);
  const [workGroupDescription, setWorkGroupDescrption] = useState();
  const [month, setMonth] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [monthOptions, setMonthOptions] = useState(() => {
    const months = Array.from({ length: new Date().getMonth() + 1 === 12 ? 12 : new Date().getMonth() + 2 }, (v, i) => ({
      label: (i + 1).toString(),
      value: (i + 1)
    }));
    return months;
  });
  const [fetchAllAsset, setFetchAllAsset] = useState([]);
  const [userLocationOptions, setUserLocationOptions] = useState([]);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [userLocation, setUserLocation] = useState();
  const [userDepartment, setUserDepartment] = useState();
  const [openResultsDialog, setOpenResultsDialog] = useState(false);
  const [enableGenerateButton, setEnableGenerateButton] = useState(false);
  const [enableGetResultsButton, setEnableGetResultsButton] = useState(false);
  const [allRows, setAllRows] = useState([]);
  const [fetchRows, setFetchRows] = useState([]);
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});  // State to track validation errors
  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const token = getAuthToken("id_token");
  const [gridLoading, setGridLoading] = useState();
  const [typeCode, setTypeCode] = useState();
  const [taskCode, setTaskCode] = useState();
  const [gridCount, setGridCount] = useState(0);

  const [currentPage, setCurrentPage] = useState(0); // To track the current page
  const [runOnceAtLoading, setRunOnceAtLoading] = useState(false);
  const colDefs = [
    {
      field: "workorderNo", headerName: "Work Order No",

    },
    {
      field: "workgroupcode", headerName: "Work Group",

    },

    {
      field: "assetNo", headerName: "Asset No",

    },
    {
      field: "assetdesc", headerName: "Asset Description",

    },


    {
      field: "departmentdesc", headerName: "Department Description",

    },
    {
      field: "typedesc", headerName: "Type Description",

    },
    {
      field: "workorderdate", headerName: "Work Order Date",

    },
    {
      field: "targetdate", headerName: "PPM Date",

    },
    {
      field: "Actions", headerName: "Check List",
      cellRenderer: (params) => (
        <ActionsCellRenderer data={params.data} ppmCheckList={ppmChecklist} serviceType={serviceType} />
      ),

    },

  ];

  const [openModal, setOpenModal] = useState(false);
  const [reportdata, setReportdata] = useState([]);
  const [reportdataForViewAndDownload, setReportdataForViewAndDownload] = useState([]);

  const [dataForReport, setDataForReport] = useState([]);
  const [ppmChecklist, setPpmCheckList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [textLoading, setTextLoading] = useState(false);
  const hasRunOnce = useRef(false);
  const pageLoaderForPage = useRef(false);
  const fetchOptions = async () => {
    try {
      setErrors({});
      setYear({});
      setUserLocation();
      setUserDepartment('');
      const workgroupdetails = await commonMasterRepository.getWorkGroupDetails(facilityId);
      setWorkGroupOptions(workgroupdetails);
      setWorkGroup(workgroupdetails?.find((item) => item?.label === 'W1'))

      const responseMasters = await commonMasterRepository.getMasters(facilityId, companyId);
      setServiceTypeOptions(responseMasters);
      setServiceType(responseMasters?.find((item) => item?.label === 'FEMS'))

      const maintanenceyear = await commonMasterRepository.getMaintanenceYear(facilityId);

      setYearOptions(maintanenceyear?.filter((item) => Number(item?.label) === new Date().getFullYear()));
      setYear(maintanenceyear?.find((item) => Number(item?.label) === new Date().getFullYear()) || maintanenceyear[0]);

      const now = new Date();
      // Get the current month (0-based index, where 0 = January, 11 = December)
      const currentMonthIndex = getMonth(now) + 1;
      setMonth(monthOptions?.find((item) => item.value === currentMonthIndex))

      // const userLocationOptions = await PpmGenerationRepository.getLocationDetails(facilityId);
      // setUserLocationOptions(userLocationOptions);



    }
    catch (e) {
      console.log(e)
    }

  }
  const fetchList = async () => {
    try {
      setEnableGetResultsButton(false);
      pageLoaderForPage.current = true;
      const value = {
        "facilityid": facilityId,
        "workgroupdetailsId": workGroup?.id,
        "year": Number(year?.value),
        "month": month?.value,
      }
      if (serviceType?.label == 'FEMS') {
        const ppmCheckList = await PPMCheckListRepository.getPPMChecklistListForExport(facilityId);
        // setRows(ppmCheckList?.data?.items)
        setPpmCheckList(ppmCheckList?.data)
      } else if (serviceType?.label == 'BEMS') {
        const ppmCheckList = await PPMCheckListRepository.getBemsPPMChecklistListForExport(facilityId);
        // setRows(ppmCheckList?.data?.items)
        setPpmCheckList(ppmCheckList?.data)
      }
      if (serviceType?.label === 'FEMS') {
        setGridLoading(true);
        const rows = await PpmGenerationRepository.getPpmGenerationList(value);
        const list = rows?.data?.ppmGenerationLists?.map((item) => {
          return {
            ...item,
            workorderdate: format(new Date(item?.workorderdate), "dd/MM/yyyy"),
            targetdate: format(new Date(item?.targetdate), "dd/MM/yyyy")
          }
        });
        setAllRows(list?.sort((a, b) => a.workorderNo.localeCompare(b.workorderNo)));
        setReportdata(rows?.data?.ppmGenerationLists);
        const fetchRows = await PpmGenerationRepository.getPPMGenerationFetch(facilityId, workGroup?.id);
        setFetchRows(fetchRows?.data);
        const assetList = await PpmPlannerRepository.getAssetNoDetails(facilityId, workGroup?.id);
        setFetchAllAsset(assetList);
      } else if (serviceType?.label === 'BEMS') {
        const rows = await PpmGenerationRepository.getPpmGenerationListBEMS(value);
        const list = rows?.data?.ppmGenerationLists?.map((item) => {
          return {
            ...item,
            workorderdate: format(new Date(item?.workorderdate), "dd/MM/yyyy"),
            targetdate: format(new Date(item?.targetdate), "dd/MM/yyyy")
          }
        });
        setAllRows(list?.sort((a, b) => a.workorderNo.localeCompare(b.workorderNo)));
        setReportdata(rows?.data?.ppmGenerationLists);
        const fetchRows = await PpmGenerationRepository.getBEMSPPMGenerationFetch(facilityId, workGroup?.id);
        setFetchRows(fetchRows?.data);
        const assetList = await PpmPlannerRepository.getBemsAssetNoDetails(facilityId, workGroup?.id);
        setFetchAllAsset(assetList);
      }

    } catch (e) {
      console.log(e)
    }
    finally {
      await enableButton();
      setGridLoading(false);
      setTextLoading(true);
    }
  }
  const enableButton = async () => {
    try {
      const mismatchRows = await getMisMatchRows();
      // Process mismatchRows
      await Promise.all(mismatchRows)
        .then((results) => {
          if (results.length > 0) {
            hasRunOnce.current = false;
            setEnableGenerateButton(true);
            setEnableGetResultsButton(true);
          }
        })
        .catch((error) => {
          console.error("Error details:", error);
        })
        .finally(() => {
          // Ensure loader is stopped in all cases
          pageLoaderForPage.current = false;
          setEnableGetResultsButton(true);
          hasRunOnce.current = false;
        });
    } catch (error) {
      console.log("error", error);
      // Handle the error and stop the loader
      pageLoaderForPage.current = false;
    }
  };

  useEffect(() => {
    const getList = async () => {
      if (serviceType?.id && workGroup?.id && year?.id && month?.value && openResultsDialog === false && hasRunOnce.current === false) {
        setEnableGetResultsButton(false);
        setEnableGenerateButton(false);
        hasRunOnce.current = true;
        await fetchList();
      }
    }
    getList();
  }, [workGroup, year, month]);


  useEffect(() => {
    fetchOptions();
  }, []);
  const getMisMatchRows = async () => {
    try {
      let result;
      let checkAllRows;
      setEnableGenerateButton(false);
      const value = {
        "facilityid": facilityId,
        "workgroupdetailsId": workGroup?.id,
        "year": Number(year?.value),
        "month": month?.value,
      }
      if (serviceType?.label === 'FEMS') {
        const rows = await PpmGenerationRepository.getPpmGenerationList(value);
        // checkAllRows = rows?.data?.ppmGenerationLists?.filter((item)=>item.status==="Scheduled");
        checkAllRows = rows?.data?.ppmGenerationLists;

      } else {
        const rows = await PpmGenerationRepository.getPpmGenerationListBEMS(value);
        // checkAllRows = rows?.data?.ppmGenerationLists?.filter((item)=>item.status==="Scheduled");
        checkAllRows = rows?.data?.ppmGenerationLists;

      }
      const yearAsNumber = Number(year?.value);
      const monthAsNumber = month?.value;
      const ppmList = serviceType?.label === "FEMS" ? await PpmPlannerRepository.getPpmGenerationShowSchedule(facilityId, workGroup?.id, yearAsNumber, monthAsNumber) : await PpmPlannerRepository.getBemsPpmGenerationShowSchedule(facilityId, workGroup?.id, yearAsNumber, monthAsNumber);
      if (checkAllRows?.length > 0 && ppmList?.data?.length >= 0) {
        if (serviceType?.label === "FEMS") {
          result = ppmList?.data?.filter(item1 =>
            !checkAllRows.some(item2 => ((item1?.femppmscheduledetails?.femassetregister?.assetno === item2?.assetNo) && (item1?.targetdate === item2?.targetdate)))
          );
        } else {
          result = ppmList?.data?.filter(item1 =>
            !checkAllRows.some(item2 => ((item1?.bemppmscheduledetails?.bemassetregister?.assetno === item2?.assetNo) && (item1?.targetdate === item2?.targetdate)))
          );
        }
        if (result?.length > 0) {
          let mismatched = result.filter(item => ((getMonth(item?.targetdate) + 1 === month?.value) && (getYear(new Date(item?.targetdate)) === Number(year?.value))))
          if (mismatched?.length > 0) {
            return mismatched;
          } else {
            return [];
          }
        } else {
          return [];
        }
      } else if (ppmList?.data?.length > 0) {
        let mismatched = ppmList?.data?.filter(item => ((getMonth(item?.targetdate) + 1 === month?.value) && (getYear(new Date(item?.targetdate)) === Number(year?.value))))
        // let mismatched = ppmList?.data.filter(item => getMonth(item?.targetdate) + 1 === month?.value)
        if (mismatched?.length > 0) {
          return mismatched;
        } else {
          return [];
        }
      } else {
        return [];
      }
    } catch (error) {
      console.error('reschedule error:', error);
      return error;
    }
  }
  const listLength = useMemo(() => { return allRows?.length || 0 }, [allRows])
  const wgdesc = useMemo(() => { setWorkGroupDescrption(workGroup?.wgdesc) }, [workGroup])
  const serviceTypeChange = useMemo(() => {
    const fetchOption = async () => {
      try {
        if (serviceType?.label === 'BEMS') {
          const workgroupdetails = await commonMasterRepository.getBemsWorkGroupDetails(facilityId);
          setWorkGroupOptions(workgroupdetails);
          setWorkGroup(workgroupdetails?.find((item) => item?.label === 'W8'))
        }
        if (serviceType?.label === 'FEMS') {
          const workgroupdetails = await commonMasterRepository.getWorkGroupDetails(facilityId);
          setWorkGroupOptions(workgroupdetails);
          setWorkGroup(workgroupdetails?.find((item) => item?.label === 'W1'))
        }
      }
      catch (e) {
        console.error(e)
      }
    }
    fetchOption();
  }, [serviceType]);

  const handleGetResults = async () => {
    const newErrors = {};
    if (!year) newErrors.year = "Year is required";
    if (!month) newErrors.month = "Month is required";
    if (!serviceType) newErrors.serviceType = "Service Type is required";
    if (!workGroup) newErrors.workGroup = "Work Group is required";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      setErrors({});
      try {
        if (serviceType?.label === "FEMS") {
          setOpenResultsDialog(true);
        } else if (serviceType?.label === "BEMS") {
          // Implement for BEMS if needed
          setOpenResultsDialog(true);
        }
      } catch (e) {
        console.error(e);
      }
    }
  }
  const handleRefresh = async () => {
    await fetchOptions();
  }
  const handleGridRefresh = () => {
    fetchList();
  }
  const handleCancelClick = () => {
    navigate('/dashboard');
    dispatch(setSelectedIndex('SET_INDEX_LABEL', ''));
    dispatch(setHeaderName('SET_HEADER_NAME', 'Dashboard'));
  }
  const getDates = useMemo(() => {
    if (Number(year?.value) && month) {

      // Create a date object for the first day of the month
      const date = new Date(Number(year?.value), month?.value - 1, 1);

      // Get the start and end dates of the month
      const startDates = startOfMonth(date);
      const endDates = endOfMonth(date);
      // Format the dates as dd/mm/yyyy
      setStartDate(format(startDates, 'dd/MM/yyyy'));
      setEndDate(format(endDates, 'dd/MM/yyyy'));
    } else {
      setStartDate('');
      setEndDate('');
    }
  }, [year, month])

  const ResultsDialog = ({ open, onClose, serviceType }) => {
    const [allRowData, setAllRowData] = useState([]);
    const [dataLoading, setDataLoading] = useState(false);
    const [gridApis, setGridApis] = useState({});
    const hasRun = useRef(false);
    const allData = useRef([]);
    const fetchListData = async () => {
      if (open) {
        try {
          setDataLoading(true);
          if (serviceType?.label === 'FEMS') {
            const fetchlists = await PpmGenerationRepository.getPPMGenerationFetch(facilityId, workGroup?.id);

            if (fetchlists?.status <= 204) {
              const allList = fetchlists.data?.map((item) => {
                return { ...item, workgroup: workGroup?.value, service: serviceType?.value }
              })
              allData.current = allList;
            }
          }
          else if (serviceType?.label === 'BEMS') {
            const fetchlists = await PpmGenerationRepository.getPPMGenerationFetchBEMS(facilityId, workGroup?.id);
            if (fetchlists?.status <= 204) {
              const allList = fetchlists.data?.map((item) => {
                return { ...item, workgroup: workGroup?.value, service: serviceType?.value }
              })
              allData.current = allList;
            }
          }
        }
        catch (e) {
          console.error(e)
        }
        finally {
          setDataLoading(false);
        }
      }
    }
    const handleGridRefreshFetch = async () => {
      await fetchListData();
    }
    useEffect(() => {
      if (!hasRun.current) {
        fetchListData();
      }

    }, [])

    const resultsColDefs = [
      { field: "assetName", headerName: "Asset No" },
      { field: "assetDescription", headerName: "Asset Description" },
      { field: "service", headerName: "Service" },
      { field: "workgroup", headerName: "Work Group" }
    ];
    return (
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle sx={{ fontSize: '1.5rem', fontWeight: 'bold', padding: '16px' }}>PPM Generation Asset Details</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>  <Grid item xs={8} md={11}><Typography variant="h6" fontWeight="bold"> {`List Of Assets : ${allData.current?.length}`}</Typography></Grid>
            <Grid item xs={4} md={1} sx={{ marginBottom: "10px", display: "flex", justifyContent: "flex-end" }}><RefreshExportButtons pagination={false} exportFunction={() => { }} exportData={allRowData} title='PPM Generation Fetch' refData={gridApis} handleRefresh={handleGridRefreshFetch} /></Grid></Grid>

          <CustomAgGrid
            ref={gridApis}
            setGridApi={setGridApis}
            // rows={allRowData}
            rows={allData.current}
            columns={resultsColDefs}
            isEnableView={false}
            disableFilter={false}
            isLoading={dataLoading}
            headerLayer={3}
          />
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={onClose} color="primary" sx={{ margin: "10px" }}>
            close
          </Button>
        </DialogActions>
      </Dialog>
    )
  };
  const handleGenerateClick = async () => {
    try {
      let mismatched = await getMisMatchRows();
      if (mismatched?.length > 0) {
        // setLoading(true);
        pageLoaderForPage.current = true;
        setGridLoading(true);
        await new Promise((resolve) => setTimeout(resolve, 0));
        const responseBody = await Promise.all(mismatched?.map(async (item) => {
          const workOrderNo = await PpmGenerationRepository.getWorkOrderNo(facilityId, token);
          const palyload = serviceType?.label === "FEMS" ? {
            "Workorderno": workOrderNo,
            "isdeleted": false,
            "workorderdate": formatISO(new Date()),
            "targetdate": item?.targetdate,
            "requestdetails": "Preventive Maintenance Work Order",
            "femppmscheduletrack": {
              "id": item?.id,
            },
            "femworkorderstatus": {
              "id": 2,
              "workorderstatus": "Scheduled"
            },
            "femworkordertype": {
              "id": 6,
              "workordertype": "PPM"
            },
            "femworkorderpriority": {
              "id": 1,
              "workorderpriority": "Normal",
            },
            "femworkordersafetyperformtest": {
              "id": 1,
              "safetyperformancetest": "Yes"

            },
            "femwotargetresponse": {
              "id": 1,
              "targetresponse": "120 min"
            },
            "Processingpercentage": 16,

          } : {
            "Workorderno": workOrderNo,
            "isdeleted": false,
            "workorderdate": formatISO(new Date()),
            "targetdate": item?.targetdate,
            "requestdetails": "Preventive Maintenance Work Order",
            "bemppmscheduletrack": {
              "id": item?.id,
            },
            "bemworkorderstatus": {
              "id": 2,
              "workorderstatus": "Scheduled"
            },
            "bemworkordertype": {
              "id": 6,
              "workordertype": "PPM"
            },
            "bemworkorderpriority": {
              "id": 1,
              "workorderpriority": "Normal",
            },
            "bemworkordersafetyperformtest": {
              "id": 1,
              "safetyperformancetest": "Yes"

            },
            "bemwotargetresponse": {
              "id": 1,
              "targetresponse": "120 min"
            },
            "Processingpercentage": 16,

          };
          return palyload;
        }));
        if (responseBody) {
          const setWorkOreder = responseBody.map(async (item) => {
            const updatePpmScheduleTracks = serviceType?.label === "FEMS" ? await PpmGenerationRepository.regenerateWorkOrder(item) : await PpmGenerationRepository.regenerateBemsWorkOrder(item);
            return updatePpmScheduleTracks;
          })
          const updatePpmScheduleTracksInsert = await Promise.all(setWorkOreder);



          const allSuccessful = updatePpmScheduleTracksInsert.every(item => item.status >= 200 && item.status <= 204);

          if (allSuccessful) {
            setEnableGenerateButton(false);
            setConfirmationDialogOpen(true);
            // fetchList();
            // setLoading(false);
            pageLoaderForPage.current = false;
            setGridLoading(true);
            const value = {
              "facilityid": facilityId,
              "workgroupdetailsId": workGroup?.id,
              "year": Number(year?.value),
              "month": month?.value,
            }
            if (serviceType?.label === 'FEMS') {

              // const ppmCheckList = await PPMCheckListRepository.getPPMChecklistListForExport(facilityId);

              // setPpmCheckList(ppmCheckList?.data)
              const rows = await PpmGenerationRepository.getPpmGenerationList(value);
              const list = rows?.data?.ppmGenerationLists?.map((item) => {
                return {
                  ...item,
                  workorderdate: format(new Date(item?.workorderdate), "dd/MM/yyyy"),
                  targetdate: format(new Date(item?.targetdate), "dd/MM/yyyy")
                }
              });
              setAllRows(list?.sort((a, b) => a.workorderNo.localeCompare(b.workorderNo)));




            } else {
              // const ppmCheckList = await PPMCheckListRepository.getBemsPPMChecklistListForExport(facilityId);

              // setPpmCheckList(ppmCheckList?.data)
              const rows = await PpmGenerationRepository.getPpmGenerationListBEMS(value);
              const list = rows?.data?.ppmGenerationLists?.map((item) => {
                return {
                  ...item,
                  workorderdate: format(new Date(item?.workorderdate), "dd/MM/yyyy"),
                  targetdate: format(new Date(item?.targetdate), "dd/MM/yyyy")
                }
              });
              setAllRows(list?.sort((a, b) => a.workorderNo.localeCompare(b.workorderNo)));
            }
            await fetchList();
            setGridLoading(false);
          } else {
            console.error("Some promises failed");
          }
        }
      }
    } catch (error) {
      console.error('reschedule error:', error);
    }
  }
  const handleViewClick = async () => {
    const api = gridRef.current.api;
    const newPage = api.paginationGetCurrentPage(); // 0-indexed
    const records = newPage == 0 ? allRows.slice(0, 20) : reportdataForViewAndDownload;
    pageLoaderForPage.current = true;
    // setIsLoading(true);
    setIsView(true);
    try {
      if (serviceType?.label === 'FEMS') {
        if (records?.length > 0) {
          const promises = records.map(async (item) => {
            try {
              // Check if workorderId exists before making the API call
              if (!item?.workorderId) {
                console.warn(`Missing workorderId for item: ${JSON.stringify(item)}`);
                return undefined; // Handle case where workorderId is undefined
              }

              // Fetch work order details
              const getWorkOrderDetails = await PpmGenerationRepository.getFemsWorkOrderDetails(facilityId, item.workorderId);

              if (!getWorkOrderDetails) {
                console.warn(`No work order details found for workorderId: ${item.workorderId}`);
                return undefined; // Handle case where no data is returned
              }

              return getWorkOrderDetails;
            } catch (error) {
              console.error(`Error fetching work order details for workorderId: ${item.workorderId}`, error);
              return undefined; // Return undefined in case of an error
            }
          });

          // Wait for all promises to resolve
          const results = await Promise.all(promises);

          // Filter out undefined results
          const validResults = results.filter(result => result !== undefined);
          setDataForReport([...validResults]);


        }
        if (reportdata?.length > 0) {
          setOpenModal(true);
        } else {

        }
      }
      else if (serviceType?.label === 'BEMS') {
        if (records?.length > 0) {
          const promises = records.map(async (item) => {
            try {
              // Check if workorderId exists before making the API call
              if (!item?.workorderId) {
                console.warn(`Missing workorderId for item: ${JSON.stringify(item)}`);
                return undefined; // Handle case where workorderId is undefined
              }

              // Fetch work order details
              const getWorkOrderDetails = await PpmGenerationRepository.getBemsWorkOrderDetails(facilityId, item.workorderId);

              if (!getWorkOrderDetails) {
                console.warn(`No work order details found for workorderId: ${item.workorderId}`);
                return undefined; // Handle case where no data is returned
              }

              return getWorkOrderDetails;
            } catch (error) {
              console.error(`Error fetching work order details for workorderId: ${item.workorderId}`, error);
              return undefined; // Return undefined in case of an error
            }
          });

          // Wait for all promises to resolve
          const results = await Promise.all(promises);

          // Filter out undefined results
          const validResults = results.filter(result => result !== undefined);
          setDataForReport([...validResults]);


        }
        if (records?.length > 0) {
          setOpenModal(true);
        } else {

        }
      }

    } catch (e) {

    }
    finally {
      pageLoaderForPage.current = false;
  
    }
  }
  // Get current page records
  const getCurrentPageRecords = () => {
    const currentPage = gridRef?.current?.api?.paginationGetCurrentPage(); // Get current page (0-indexed)
    const startIndex = currentPage * 20;
    const endIndex = startIndex + 20;
    return allRows.slice(startIndex, endIndex);
  };

  // Handle page changes
  const onPaginationChanged = () => {
    if (gridRef.current) {
      const api = gridRef.current.api;
      const newPage = api.paginationGetCurrentPage(); // 0-indexed
      if (newPage !== currentPage) {
        const currentPageRecords = getCurrentPageRecords();
        setReportdataForViewAndDownload(currentPageRecords);
        setCurrentPage(newPage);
      }
    }

  };


  return (
    <>
      <PageLoader open={pageLoaderForPage.current} />
      <Box mt={{ xs: 1, sm: 2 }}>
        <DefaultCard>
          <Grid container spacing={2}>

            <Grid item xs={12} md={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              {allRows?.length > 0 ? <Typography variant='title2' sx={{ backgroundColor: 'darkgreen', color: 'white', marginRight: '5px', padding: '5px', borderRadius: '5px' }} >The PPM has been generated for selected service, work group, year and month</Typography> : textLoading === true ? <Typography variant='title2' sx={{ backgroundColor: 'red', color: 'white', marginRight: '5px', padding: '5px', borderRadius: '5px' }} >The PPM has not been generated for selected service, work group, year and month</Typography> : ''}</Grid>

            <Grid item xs={6} md={4}>
              <CustomSelectInput
                id="year"
                label="Year"
                isMandatoryField={true}
                value={year}
                error={!!errors?.year}
                errorMessage={errors.year}
                options={yearOptions}
                autoFocus={true}
                onChange={(newValue) => {
                  hasRunOnce.current = false;
                  setYear(newValue);
                  setErrors({ ...errors, year: null });


                }}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomSelectInput
                id="month"
                label="Month"
                isMandatoryField={true}
                value={month}
                options={monthOptions}
                error={!!errors?.month}
                errorMessage={errors.month}
                onChange={(newValue) => {
                  hasRunOnce.current = false;
                  setMonth(newValue);
                  setErrors({ ...errors, month: null });


                }}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomSelectInput
                id="servicetype"
                label="Service Type"
                isMandatoryField={true}
                value={serviceType}
                error={!!errors?.serviceType}
                errorMessage={errors.serviceType}
                options={serviceTypeOptions}
                onChange={(newValue) => {
                  hasRunOnce.current = false;
                  setServiceType(newValue);
                  setErrors({ ...errors, serviceType: null });

                }}
              />
            </Grid>

            <Grid item xs={6} md={4}>
              <CustomSelectInput
                id="workgroup"
                label="Work Group"
                isMandatoryField={true}
                value={workGroup}
                error={!!errors?.workGroup}
                errorMessage={errors.workGroup}
                options={workGroupOptions}
                onChange={(newValue) => {
                  hasRunOnce.current = false;
                  setWorkGroup(newValue);
                  setErrors({ ...errors, workGroup: null });

                }}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomTextField
                label="Workgroup Description"
                id="workgroupdescription"
                isRefilByOtherField={true}
                placeholder={false}
                value={workGroupDescription}
                onChange={(newValue) => {

                  setWorkGroupDescrption(newValue);

                }}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomTextField
                label="Start Date"
                id="Start Date"
                isRefilByOtherField={true}
                placeholder={false}
                value={startDate}
                onChange={(newValue) => {

                }}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomTextField
                label="End Date"
                id="End Date"
                isRefilByOtherField={true}
                placeholder={false}
                value={endDate}
                onChange={(newValue) => {

                }}
              />
            </Grid>
          </Grid>

          <Box
            sx={{
              marginTop: "10px",
              display: "flex",
              gap: 2,
              justifyContent: { xs: "center", md: "end" },
            }}
          >
            <Button disabled={!enableGetResultsButton} variant='contained' onClick={handleGetResults}>Get Results</Button>
            <Button variant='outlined' onClick={handleRefresh}>Refresh</Button>

          </Box>    </DefaultCard></Box>

      <Box mt={{ xs: 1, sm: 2 }}>
        <DefaultCard>
          <Grid container spacing={2}>  <Grid item xs={8} md={11}><Typography variant="h6" fontWeight="bold">   {`List Of Assets : ${gridCount > 0 ? gridCount : listLength}`}</Typography></Grid>
            <Grid item xs={4} md={1} sx={{ marginBottom: "10px", display: "flex", justifyContent: "flex-end" }}><RefreshExportButtons pagination={false} exportFunction={() => { }} exportData={allRows} title='PPM Generation' refData={gridApi} handleRefresh={handleGridRefresh} /></Grid></Grid>

          <CustomAgGrid
            paginationSize={20} // this line for no.of records per each page
            ref={gridApi}
            setGridApi={setGridApi}
            rows={allRows}
            columns={colDefs}
            isEnableView={false}
            disableFilter={false}
            isLoading={gridLoading}
            headerLayer={3}
            onPaginationChanged={onPaginationChanged}
            gridRefs={gridRef}
            onFilteredCountChange={(item) => setGridCount(item)}
            sendFilteredCount={true} // Enable filtered count behavior
          />

          <Box
            sx={{
              display: "flex",
              gap: 2,
              justifyContent: { xs: "center", md: "end" },
            }}
          >
            <Grid container spacing={2}>

              <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: "60px", marginRight: "20px" }}>
                {((fetchRows?.length <= 0) && (enableGenerateButton)) ? ( //MAIN 
                  // {((fetchRows?.length <= 0) && (enableGenerateButton)&&(month?.value == getMonth(new Date()) + 1)) ? ( //MAIN 
                  <Button
                    variant="contained"
                    onClick={handleGenerateClick}
                    sx={{ margin: "10px" }}
                  >
                    Generate
                  </Button>
                ) : null}
                {reportdata?.length > 0 ? <Button variant='contained' onClick={handleViewClick} sx={{ margin: "10px" }}>View All</Button> : ''}
                <Button variant='outlined' onClick={handleCancelClick} sx={{ margin: "10px" }}>Back</Button>
              </Grid>
            </Grid>
          </Box>
        </DefaultCard>
      </Box>


      <ResultsDialog
        open={openResultsDialog}
        onClose={async () => {
          setOpenResultsDialog(false);
          await fetchList();
          // await enableButton();
        }}
        serviceType={serviceType}
      />


      <Dialog
        open={openModal}

        maxWidth="lg"
        fullWidth
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          ...(!isView && {
            "& .MuiBackdrop-root": {
              backgroundColor: "transparent",
            },
            top: "-9999px",
            left: "-9999px",
            zIndex: "-1",
          })
        }}
      >
        <DialogContent>
          <Kpirepairdownload

            reportdata={dataForReport}
            setOpenModal={setOpenModal}
            year={year}
            serviceType={serviceType}
            typeCodeId={typeCode}
            taskCodeId={taskCode}
            setCloseViewLoader={(item) => pageLoaderForPage.current = item}
          //autoDownload={true}
          />
        </DialogContent>
      </Dialog>
      <CustomDialog
        open={confirmationDialogOpen}
        onClose={() => setConfirmationDialogOpen(false)}
        content={<>{commonMessages.generateSuccessMessage}</>}
        confirmBtn="OK"
        onConfirm={() => setConfirmationDialogOpen(false)}
      />

    </>
  )
};
export default PpmGenerationList